import { ROUTES } from '@/common/auth-routes';
import { AgentsIcon, AllAppsIcon } from './sidebar-icons';

export interface NavItem {
  id: string;
  title: string;
  route: string;
  icon: React.ComponentType<{ className?: string }>;
  disabled?: boolean;
}

export const NAVIGATION_ITEMS: NavItem[] = [
  {
    id: 'your-apps',
    title: 'Your Apps',
    route: ROUTES.DASHBOARD,
    icon: AllAppsIcon,
  },
  {
    id: 'agents',
    title: 'Agents',
    route: ROUTES.AGENTS,
    icon: AgentsIcon,
  },
];
